"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  ", "\n"], ["\n  ", "\n"]);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _buoyText = require("buoy-text");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Li = _styledComponents2.default.li.withConfig({
  displayName: "Li",
  componentId: "sc-19q2tti-0"
})(_templateObject, _buoyText.ParagraphStyle);

Li.defaultProps = {
  fontSize: "bodyMain"
};

exports.default = Li;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-list/dist/components/Li.js
// module id = 226
// module chunks = 168707334958949